import { Link } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { Button } from "../components/ui/Button";
import { apiFetch } from "../api/client";
import { useState } from "react";

export function SettingsTeam() {
  const me = useAuthStore((s) => s.me);
  const [code, setCode] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function invite() {
    setError(null);
    try {
      const res = await apiFetch<{ code: string }>("/api/v1/invites", {
        method: "POST",
        body: JSON.stringify({ role: "driver" }),
      });
      setCode(res.code);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Invite failed");
    }
  }

  return (
    <div className="stack">
      <Link to="/settings" className="muted back-link">
        ← Settings
      </Link>
      <h1 className="screen-title">Team</h1>
      <div className="card stack">
        {(me?.memberships ?? []).map((m) => (
          <div key={m.orgId} className="list-item">
            <span>{m.orgName}</span>
            <span className="chip">{m.role}</span>
          </div>
        ))}
        {me?.role === "owner" ? (
          <Button variant="primary" onClick={() => void invite()}>
            Invite driver
          </Button>
        ) : (
          <p className="muted">Only owners can invite</p>
        )}
        {code ? <p>Invite code: {code}</p> : null}
        {error ? <p className="legal-flag">{error}</p> : null}
      </div>
    </div>
  );
}
